import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import {  useDispatch } from 'react-redux';
import {  Grid, TextField, Typography, makeStyles } from "@material-ui/core";
import { renameAsset } from '../../../store/assets/actions';
import { basicFolderFileName, validationMessages, assetFileName } from '../../../config/validations';
import { invokeGetService,  setApiResponseMessage, setApiResponseCode, toggleRightDrawer, setReRender } from "../../../store/global/actions";
import { ApiResponseAlert } from '../alerts/ApiResponseAlert';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { validateNonAsciiChars } from "../../../utils/commonUtils";

const useStyles = makeStyles((theme) => ({
    name_field: {
        paddingTop: '4px',
        paddingBottom: '4px'
    },

    extension_field: {
        margin: 'auto',
        paddingLeft: 0
    },

    extension: {
        fontWeight: 'bold'
    }
}))


export default function RenameAsset({ onClose, onCompletion, parent, item }) {

    const classes = useStyles();
    
    const dispatch = useDispatch();
    const name = item?.type == "file" ? getFileDetails(item.assetName)?.file_name : item.assetName ;
    const { register, handleSubmit, formState: { errors }, reset, setError } = useForm({ defaultValues: { name: name, description: item?.description} });
    const [assetName, setAssetName] = useState(name);
    const [accesAlert, setAccessAlert] = useState(false)

    const showDescription = item?.type == "file" ? true : false;
    const showExtension = item?.type == "file" ? true : false;
    

    useEffect(() => {

        dispatch(invokeGetService('getAssetData', [item._id]))
            .then((response) => {
                if (response.status) {
                    const actual_name = response?.data?.assetName;
                    setAssetName(item?.type == "file" ? getFileDetails(actual_name)?.file_name : actual_name);

                }
            })
    }, [])

    useEffect(() => {

        reset({
            name: name
        })

    }, [assetName])

    function getFileDetails(filename) {
        const lastDotIndex = filename.lastIndexOf(".");
        
        if (lastDotIndex === -1) {
            return { file_name: filename, extension: "" };
        }
    
        return {
            file_name: filename.substring(0, lastDotIndex),
            extension: filename.substring(lastDotIndex)
        };
    }

    const {file_name, extension} = getFileDetails(item && item?.type == "file" ? item?.assetName : "" );

    const onRename = async ({ name, description }) => {
        const formattedName = item?.type == "file" && extension ? `${name}${extension}` : name;
        const data = { 
            name: formattedName, 
            _id: item._id,
             blueprintId: item.blueprintId, 
             parent: item.parent 
            }
        if(description){
            data.description = description;
        }
            

        const result = await dispatch(renameAsset(data))
        if (result.status) {
            dispatch(setReRender());
            onCompletion(item.type == 'folder' ? 'Directory' : 'File', 'rename', true);
        }
        else if (result.code && result.code != process.env.REACT_APP_FORM_ERROR_CODE) {
            if ([251, 252, 253, 254, 255].includes(result.code)) {
                dispatch(setApiResponseMessage(result.message))
                dispatch(setApiResponseCode(result.code))
                setAccessAlert(true)
                dispatch(toggleRightDrawer());

            }
        }
        else {
            if (result?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                result?.errors?.forEach(error => {
                    setError(error.name, { message: error.message });
                });
            }
        }
    }
    const messages = {
        ...validationMessages,
        validate: 'Duplicate asset name given'
    }


    return (
        <Grid container direction={"row"} spacing={3}>


            <Grid item xs={showExtension && extension != "" ? `11` : 12} className={classes.name_field} style={{paddingTop: '0', paddingBottom: '0'}}>
                <TextField
                    id="name"
                    type={"text"}
                    fullWidth
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    name="name"
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                    inputRef={item?.type == "file" ? register({ ...assetFileName }) : register({ ...basicFolderFileName })}
                />
            </Grid>

            {showExtension && extension != "" &&
            <Grid item xs={1} className={`${classes.extension_field} asset_file_extension`} style={{paddingLeft: 0, paddingTop: '0', paddingBottom: '0'}}>
                <Typography className={classes.extension}> {extension} </Typography>
            </Grid>} 

            { showDescription && 
            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    placeholder={""}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars})}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <UpdateCancel onUpdate={handleSubmit(onRename)} onCancel={onClose} typesNotIn={['transaction', 'view']} content={'Rename'} />

            </Grid>
            {accesAlert && <ApiResponseAlert />}

        </Grid>


    );

}